import React from 'react';
import { Box, Typography } from '@mui/material';
import { withLanguage } from '../common/Texts';
import { resultsTokens as t } from './tokens';

export default function ResultsHeader({ language, count }) {
    const tr = withLanguage(language);

    return (
        <Box sx={{ mb: 3 }}>
            <Typography component="h1" sx={{
                fontSize: 24,
                fontWeight: 700,
                color: t.color.fg,
                lineHeight: 1.2,
            }}>
                {tr('results')}
            </Typography>
            <Typography sx={{ fontSize: 13, color: t.color.fgMuted, mt: 0.5 }}>
                {count} {tr('assessed')}
            </Typography>
        </Box>
    );
}
